module.exports = __webpack_public_path__ + "static/img/4.c762b5a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/zh/4.png
// module id = BCHo
// module chunks = 0